module.exports = __webpack_public_path__ + "static/assets/215834e51707ed53819f640d55a7f351.svg";